import * as _ from 'lodash';
import { getProjectOptionsByEnvironment } from '../../../services/mini/getProjectOptionsByEnvironment';
import { getDefaultOptionsValue } from './defaultProjectOptions';

export function getBoolOption(props, optionName, optionNameOld?) {
    const { project, platform, environment, cohorts, selectedCohortId } = props;

    const currentOptions = props.currentOptions;

    if (currentOptions) {
        if (currentOptions && !_.isUndefined(_.get(currentOptions, optionName))) {
            return _.get(currentOptions, optionName);
        }
        return getDefaultOptionsValue(platform, optionName);
    }

    const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

    if (project) {
        if (options[platform] && !_.isUndefined(_.get(options[platform], optionName))) {
            return _.get(options[platform], optionName);
        }
        if (options[platform] && !_.isUndefined(_.get(options[platform], optionNameOld))) {
            return _.get(options[platform], optionNameOld);
        }
    }
    return getDefaultOptionsValue(platform, optionName);
}

export function getStringOption(props, optionName, optionNameOld?) {
    const { project, platform, environment, cohorts, selectedCohortId } = props;

    const currentOptions = props.currentOptions;

    if (currentOptions) {
        if (currentOptions && !_.isUndefined(_.get(currentOptions, optionName))) {
            return _.get(currentOptions, optionName);
        }
        return getDefaultOptionsValue(platform, optionName);
    }

    const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

    if (project) {
        if (options[platform] && !_.isUndefined(_.get(options[platform], optionName))) {
            return _.get(options[platform], optionName);
        }
        if (options[platform] && !_.isUndefined(_.get(options[platform], optionNameOld))) {
            return _.get(options[platform], optionNameOld);
        }
    }
    return getDefaultOptionsValue(platform, optionName);
}